var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-useful-files"},[_c('BannerUsefulFilesSection'),_c('UserfulFilesIntroSection'),_c('UsefulFilesCardsSections')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }